export class TipoProvvedimento{
    id:number;
    provvedimento:string;    
}